import type * as React from "react";
import { cn } from "~/lib/utils";

interface SurfaceCardProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

export function SurfaceCard({
  children,
  className,
  ...props
}: SurfaceCardProps) {
  return (
    <section
      className={cn(
        "rounded-[var(--radius)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] p-5",
        className,
      )}
      {...props}
    >
      {children}
    </section>
  );
}
